import React, {
    PureComponent,
} from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

class CarouselArrow extends PureComponent {
    render() {
        const {
            currentSlide, totalSlides, slidesToShow, className, onClick, arrowSide
        } = this.props;

        const isLastSlideSection = totalSlides - currentSlide <= slidesToShow;

        if (
            (arrowSide === 'right' && isLastSlideSection) ||
            (arrowSide === 'left' && currentSlide === 0)
        ) {
            return null;
        }

        return (
            <div className={className} onClick={onClick}>
                <Svg
                    iconName={arrowSide}
                    size={'Small'}
                />
            </div>
        );
    }
}

CarouselArrow.propTypes = {
    currentSlide: PropTypes.number,
    totalSlides: PropTypes.number,
    slidesToShow: PropTypes.number,
    className: PropTypes.string,
    onClick: PropTypes.func,
    arrowSide: PropTypes.string
};

export default CarouselArrow;



// WEBPACK FOOTER //
// ./src/client/components/Carousel/CarouselArrow.js